<template>
  <div>
    <div class="text-center mb-3">
      <img :src="`${app.logo}?tr=h-125`" class="logo" />
    </div>
    <div class="card" :class="$style.container">
      <div class="text-dark mb-3 text-center">
        <strong class="font-size-24"> {{ $t('authForm.loginTitle') }} </strong>
        <div class="font-size-21"> {{ $t('authForm.signInDesc') }} </div>
      </div>
      <div class="mb-4">
      </div>
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input
            size="large"
            placeholder="Email"
            v-decorator="[
              'email',
              {
                rules: [
                  { required: true, message: $t('authForm.requiredEmail') },
                  { type: 'email', message: $t('authForm.formatEmail')}
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            placeholder="Password"
            type="password"
            v-decorator="['password', { rules: [{ required: true, message: $t('authForm.requiredPassword') }]}]"
          />
        </a-form-item>
        <div class="d-flex flex-column justify-content-center align-items-center mb-4">
          <vue-recaptcha
            sitekey="6LeO3zwiAAAAAJn7WDRN9CzqkIqflxiYLPb4awa7"
            ref="recaptcha"
            @verify="isCaptchaValid = true"
            @error="isCaptchaValid = false"
            @expired="isCaptchaValid = false"
          />
          <div v-if="showWarningCaptcha" class="validation-message mt-2 p-2">
            Captcha is Required
          </div>
        </div>
        <a-button
          type="primary"
          htmlType="submit"
          size="large"
          class="text-center w-100"
          :loading="loading"
        >
          <strong> {{ $t('authForm.signIn') }} </strong>
        </a-button>
      </a-form>
      <router-link to="/auth/forgot-password" class="kit__utils__link font-size-16"> {{ $t('authForm.forgotPassword') }} </router-link>
    </div>
    <div class="text-center pt-2 mb-auto" v-if="$store.state.app.name.toLowerCase() !== 'halwey'">
      <span class="mr-2"> {{ $t('authForm.dontHaveAccount') }} </span>
      <router-link to="/auth/register" class="kit__utils__link font-size-16"> {{ $t('authForm.register') }} </router-link>
    </div>
  </div>
</template>
<script>

import { mapState, mapGetters } from 'vuex'
import { VueRecaptcha } from 'vue-recaptcha'

export default {
  name: 'CuiLogin',
  components: {
    VueRecaptcha,
  },
  computed: {
    ...mapState(['settings', 'app']),
    ...mapGetters({ loginStatusCode: 'user/loginStatusCode' }),
    loading() {
      return this.$store.state.user.loading
    },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      isCaptchaValid: false,
      showWarningCaptcha: false,
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      if (this.isCaptchaValid === true) {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.$store.dispatch('user/LOGIN', values)
              .then(({ success, message }) => {
                if (success) {
                  this.$router.push('/dashboard').catch(err => console.log({ err }))
                } else {
                  this.$notification.error({
                    message: this.$t('authForm.loginFailed'),
                    description: message,
                  })
                }
              })
          }
        })
      } else {
        this.showWarningCaptcha = true
      }
    },
    verifyCaptcha() {
      this.isCaptchaValid = true
    },
  },
  watch: {
    showWarningCaptcha: {
      immediate: true,
      handler(value) {
        if (value === true) {
          setTimeout(() => {
            this.showWarningCaptcha = false
          }, 3000)
        }
      },
    },
  },
}
</script>
<style lang="scss" module>
@import '@/components/cleanui/system/Auth/style.module.scss';
</style>
<style lang="scss" scoped>
.logo {
  max-height: 75px;
  max-width: 200px;
}
.validation-message {
  border: 1px solid transparent;
  color: #842029;
  background-color: #f8d7da;
  border-color: #f5c2c7;
  border-radius: 5px;
  max-width: 450px;
  margin: auto;
}
</style>
